import { render } from '@react-email/render';
import { useEffect, useMemo, useState } from 'react';
import {
  ClientIntakeFormEmail,
  ClientIntakeFormEmailProps,
} from '@shared/email/react/ClientIntakeFormEmail';
import { getClientIntakeFormEmailTemplate } from '@shared/email/templates/clientIntakeFormEmailTemplate';
import { renderModernEmailFooter } from '@shared/email/react/ModernEmailFooter';
import {
  EMAIL_FOOTER_MODERN_PLACEHOLDER,
  EMAIL_FOOTER_PLACEHOLDER,
  getEmailFooter,
} from '@shared/email/templates/sharedTemplates';

export function useRenderedIntakeEmail(props: ClientIntakeFormEmailProps, withFooter: boolean) {
  const {
    advisorFirstName,
    intakeFormLink,
    clientFirstName,
    advisorProvidedBody,
    advisorSignatureHtml,
  } = props;

  const [reactEmailHtml, setReactEmailHtml] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      // Mirrors the server-side addEmailFooterIfNeeded step so the preview
      // shows the email as delivered. The preferences link is inert here.
      const html = await render(
        <ClientIntakeFormEmail
          advisorFirstName={advisorFirstName}
          intakeFormLink={intakeFormLink}
          clientFirstName={clientFirstName}
          advisorProvidedBody={advisorProvidedBody}
          advisorSignatureHtml={advisorSignatureHtml}
        />,
      );
      const footer = withFooter ? await renderModernEmailFooter('#') : '';
      if (!cancelled) {
        setReactEmailHtml(html.replace(EMAIL_FOOTER_MODERN_PLACEHOLDER, footer));
      }
    })().catch(error => {
      console.error('Failed to render React Email preview:', error);
    });
    return () => {
      cancelled = true;
    };
  }, [
    advisorFirstName,
    intakeFormLink,
    clientFirstName,
    advisorProvidedBody,
    advisorSignatureHtml,
    withFooter,
  ]);

  const legacyHtml = useMemo(
    () =>
      getClientIntakeFormEmailTemplate({
        advisorFirstName,
        intakeFormLink,
        clientFirstName,
        advisorProvidedBody,
      }).replace(EMAIL_FOOTER_PLACEHOLDER, withFooter ? getEmailFooter('#') : ''),
    [advisorFirstName, intakeFormLink, clientFirstName, advisorProvidedBody, withFooter],
  );

  return { reactEmailHtml, legacyHtml };
}
